import React from "react";

export const iconClose = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <circle cx="16" cy="16" r="15.5" stroke="#EF3340" />
    <path d="M11 11L20.9996 20.9996" stroke="#EF3340" strokeLinecap="round" />
    <path d="M21 11L11.0004 20.9996" stroke="#EF3340" strokeLinecap="round" />
  </svg>
);

export const iconCloseHover = (
  <svg
    className="hover"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <circle cx="16" cy="16" r="15" stroke="#EF3340" strokeWidth="2" />
    <path d="M11 11L20.9996 20.9996" stroke="#EF3340" strokeLinecap="round" />
    <path d="M21 11L11.0004 20.9996" stroke="#EF3340" strokeLinecap="round" />
  </svg>
);
